import type { OrganizationPayload } from '@Application/Organizations/Organizations/Actions/organizationsFetched';

export type OrganizationCreatedPayload = OrganizationPayload;

export type OrganizationCreatedAction = {
	type: 'ORGANIZATION_CREATED';
	payload: OrganizationCreatedPayload;
	accountId: number;
};

export default (payload: OrganizationCreatedPayload, accountId: number): OrganizationCreatedAction => ({
	type: 'ORGANIZATION_CREATED',
	payload,
	accountId,
});
